export default __webpack_public_path__ + "static/media/icon.727a0789.jpg";